// extracted by mini-css-extract-plugin
export default {"block_buttons":"leaflet_cookies_information_block_buttons__PZbS+","button":"leaflet_cookies_information_button__Dc2xs"};